import React, {createContext, useContext, useState} from 'react';
import {Outlet} from "react-router-dom";
import {useAuthentication} from "../../Auth";
import {usePWA} from "../../Pwa";
import {useFeedbackTools} from "../../components/FeedbackTools";

import {Sidebar} from "./Sidebar";

import {styled, useMediaQuery} from '@mui/material';
import {useTheme} from '@mui/material/styles';

const MainLayoutContext = createContext();

const Layout = styled('div')(({theme}) => ({
    [theme.breakpoints.up('lg')]: {
        marginLeft: theme.custom.sidebar.width,
    },
    height: ['100vh', 'calc(var(--vh, 1vh) * 100)'], //we use array to set fallback css
    position: "relative",
}));

const MainLayout = () => {
    const [showSidebar, setShowSidebar] = useState(false);
    const {logout} = useAuthentication();
    const {checkPWAUpdates} = usePWA();
    const {showErrorNotification} = useFeedbackTools();

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {defaultMatches: true});
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    const handleSidebarOpen = () => {
        setShowSidebar(true);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    const handleSidebarSelection = () => {
        setShowSidebar(false);
        checkPWAUpdates();
    }

    const handleLogout = async () => {
        try {
            await logout();
        } catch (e) {
            showErrorNotification(e)
        }
    };

    return (
        <MainLayoutContext.Provider value={{isDesktop, isMobile, handleSidebarOpen}}>
            <Layout>
                <Outlet/>
            </Layout>

            <Sidebar open={isDesktop || showSidebar}
                     onPageSelect={handleSidebarSelection}
                     onClose={handleSidebarClose}
                     onLogout={handleLogout}
                     isDesktop={isDesktop}/>
        </MainLayoutContext.Provider>
    );
};

export default MainLayout;
export const useMainLayout = () => useContext(MainLayoutContext);